import React from 'react';
import { connect } from 'react-redux';
import { withRouter, matchPath } from 'react-router-dom';
import OptionConflictModal from './OptionConflictModal';
import {
  toggleOption,
  toggleOptionConflictCancel,
  toggleOptionConflictResolve
} from '../../store/actions';

const OptionConflictContainer = props => {
  const { location, dispatch, config, conflictConfig, conflictOption } = props;

  const onClose = () => {
    dispatch(toggleOptionConflictCancel());
  };

  const onSelect = selection => {
    dispatch(toggleOption(selection));
  };

  const onResolve = () => {
    dispatch(toggleOptionConflictResolve(conflictOption));
  };

  if (!conflictOption) {
    return null;
  }

  return (
    <OptionConflictModal
      option={conflictOption}
      previousConfig={config}
      conflictConfig={conflictConfig}
      hidePrice={!!matchPath(location.pathname, '/accessories')}
      onClose={onClose}
      onResolve={onResolve}
      onSelect={onSelect}
    />
  );
};

const mapStateToProps = state => {
  return {
    config: state.config,
    conflictConfig: state.conflictConfig,
    conflictOption: state.conflictOption
  };
};

export default withRouter(connect(mapStateToProps)(OptionConflictContainer));
